import { useStore } from '@tanstack/react-form'
import isEqual from 'lodash/isEqual'
import { FF } from 'ui/components'
import { DatePicker } from 'ui/components/DatePicker'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter/FilterWrapper'
import { FilterItemWrapper } from 'ui/temp/FilterItemWrapper'
import { TableFilterRow } from 'ui/temp/TableFilterRow'
import { emailHistoryReportFilterParamsSchema } from '~bank-reports/types/EmailHistoryReport'

import { useEmailHistoryReportContext } from '../../context/EmailHistoryReportContext'

export const Filter = () => {
  const { state, navigate, clear, formApi } = useEmailHistoryReportContext()

  const clearForm = () => {
    formApi.reset()
    clear()
  }

  return (
    <FilterPanel
      isDirty={
        useStore(formApi.store, (s) => s.isDirty) || !isEqual(emailHistoryReportFilterParamsSchema.parse({}), state)
      }
      onReset={clearForm}
    >
      <FilterWrapper>
        <TableFilterRow>
          <FilterItemWrapper isFullWidth={false}>
            <formApi.Field
              name="dateStart"
              listeners={{
                onChange: ({ value, fieldApi }) => {
                  navigate({ [fieldApi.name]: value, page: 1 })
                  return undefined
                }
              }}
              children={(field) => (
                <FF
                  label="From"
                  field={field}
                  input={(inputProps) => <DatePicker {...inputProps} data-qa="From" isClearable={false} />}
                />
              )}
            />
          </FilterItemWrapper>
          <FilterItemWrapper isFullWidth={false}>
            <formApi.Field
              name="dateEnd"
              listeners={{
                onChange: ({ value, fieldApi }) => {
                  navigate({ [fieldApi.name]: value, page: 1 })
                  return undefined
                }
              }}
              children={(field) => (
                <FF
                  label="To"
                  field={field}
                  input={(inputProps) => (
                    <DatePicker
                      {...inputProps}
                      data-qa="To"
                      value={field.state.value ?? undefined}
                      isClearable={false}
                    />
                  )}
                />
              )}
            />
          </FilterItemWrapper>
        </TableFilterRow>
      </FilterWrapper>
    </FilterPanel>
  )
}
